import template from './accountAccreditations.template.html';

export default {
  template,
  bindings: {
    account: '<',
    organization: '<',
    lenders: '<',
    gateways: '<',
    lenderCommissions: '<',
    isGroupsAndBranches: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      helperService,
      uiService,
      Accreditation,
      LenderAccreditation,
      GatewayAccreditation
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.isEnterprise = null;
      ctrl.currentCurrency = null;
      ctrl.alias = null;
      ctrl.isAlias = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.isEnterprise = $rootScope.IsEnterprise;
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.account = ctrl.account || {};
        ctrl.organization = ctrl.organization || {};
        ctrl.lenders =
          _.chain(ctrl.lenders).sortNatural('name').sortNatural('group').value() || [];
        ctrl.gateways =
          _.chain(ctrl.gateways).sortNatural('value').sortNatural('group').value() || [];
        ctrl.lenderCommissions = ctrl.lenderCommissions || [];
        ctrl.lenderAccreditations = [];
        if (!ctrl.account?.lenderAccreditations?.length) {
          const len = ctrl.lenderCommissions?.length || 0;
          for (let l = 0; l < len; l += 1) {
            const lenderCommission = ctrl.lenderCommissions[l];
            const lenderAccreditation = LenderAccreditation.build({
              id: _.uuid(),
              idLender: lenderCommission?.id || '',
              upfront: lenderCommission?.upfront || 0,
              trail: lenderCommission?.trail || 0
            });
            ctrl.account.lenderAccreditations.push(lenderAccreditation);
          }
        }
        ctrl.setLenderAccreditations();
        ctrl.setContainersStyles();
        ctrl.isReady = true;
      };

      ctrl.setLenderAccreditations = () => {
        ctrl.lenderAccreditations = _.filter(ctrl.account?.lenderAccreditations || [], (a) =>
          ctrl.showAccreditation(a)
        );
      };

      ctrl.setContainersStyles = () => {
        ctrl.lenderAccreditationsContainer = {
          height:
            ctrl.account?.lenderAccreditations?.length > 10
              ? '550px'
              : `${ctrl.account?.lenderAccreditations?.length * 55}px`,
          'margin-bottom': '1.5em'
        };
        ctrl.accreditationsContainer = {
          height:
            ctrl.account?.accreditations?.length > 10
              ? '550px'
              : `${ctrl.account?.accreditations?.length * 55}px`,
          'margin-bottom': '1.5em'
        };
        ctrl.gatewayAccreditationsContainer = {
          height:
            ctrl.account?.gatewayAccreditations?.length > 10
              ? '550px'
              : `${ctrl.account?.gatewayAccreditations?.length * 55}px`,
          'margin-bottom': '1.5em'
        };
      };

      ctrl.pickLender = (lndAcc) => {
        let canSave = true;
        const lenderAccreditation = lndAcc;
        const selectedLenders = _.filter(
          ctrl.lenderAccreditations || [],
          (l) => l?.idLender === lenderAccreditation?.idLender
        );
        if (selectedLenders?.length > 1) {
          canSave = false;
          lenderAccreditation.idLender = '';
          uiService.toast({
            text: {
              p1: 'Lender',
              p2: 'already added',
              p3: 'to accreditations'
            },
            warn: true
          });
        }
        if (canSave) {
          if (ctrl.isEnterprise) {
            const predefinedLender = _.find(
              ctrl.lenderCommissions || [],
              (commission) => commission?.id === lenderAccreditation?.idLender
            );
            if (predefinedLender?.id) {
              lenderAccreditation.trail = predefinedLender?.trail || 0;
              lenderAccreditation.upfront = predefinedLender?.upfront || 0;
            }
          }
          ctrl.saveAccountLenderAccreditations(lenderAccreditation);
        }
      };

      ctrl.lenderAccreditationAdd = () => {
        ctrl.account.lenderAccreditations.push(LenderAccreditation.blank());
        ctrl.setLenderAccreditations();
        ctrl.setContainersStyles();
        ctrl.saveAccount();
      };

      ctrl.removeLenderAccreditation = (lenderAccreditation) => {
        const idx = _.findIndex(
          ctrl.account?.lenderAccreditations || [],
          (l) => l?.idLender === lenderAccreditation?.idLender
        );
        if (idx > -1) {
          ctrl.account.lenderAccreditations.splice(idx, 1);
          ctrl.setLenderAccreditations();
          ctrl.setContainersStyles();
          ctrl.saveAccount();
        }
      };

      ctrl.accreditationAdd = () => {
        ctrl.account.accreditations.push(Accreditation.blank());
        ctrl.setContainersStyles();
      };

      ctrl.removeAccreditation = (index) => {
        ctrl.account.accreditations.splice(index, 1);
        ctrl.setContainersStyles();
        ctrl.saveAccount();
      };

      ctrl.gatewayAccreditationAdd = () => {
        ctrl.account.gatewayAccreditations.push(GatewayAccreditation.blank());
        ctrl.setContainersStyles();
      };

      ctrl.removeGatewayAccreditation = (gatewayAccreditation) => {
        const idx = _.findIndex(
          ctrl.account?.gatewayAccreditations || [],
          (l) => l?.id === gatewayAccreditation?.id
        );
        if (idx > -1) {
          ctrl.account.gatewayAccreditations.splice(idx, 1);
          ctrl.setContainersStyles();
          ctrl.saveAccount();
        }
      };

      ctrl.getLender = (lenderAccreditation) =>
        _.find(ctrl.lenders || [], (l) => l?.id === lenderAccreditation?.idLender);

      ctrl.showAccreditation = (lenderAccreditation) => {
        const hasFilteredLender = !!ctrl.getLender(lenderAccreditation);
        const isBlank = !lenderAccreditation?.idLender;
        if (isBlank || hasFilteredLender) {
          return true;
        }
        return false;
      };

      ctrl.getApplyOnlineLenderDetail = (lender = {}) =>
        _.find(
          lender.integration,
          (integration) =>
            integration.type === 'APPLY_ONLINE' || integration.type === 'NEXT_GEN'
        ) || {};

      ctrl.saveAccountLenderAccreditations = (lenderAccreditation) => {
        const idx = _.findIndex(
          ctrl.account?.lenderAccreditations || [],
          (a) => a?.idLender === lenderAccreditation?.idLender
        );
        if (idx > -1) {
          ctrl.account.lenderAccreditations[idx] = lenderAccreditation;
          ctrl.saveAccount();
        }
      };

      ctrl.saveAccount = () => {
        const data = {
          id: ctrl.account?.id,
          accreditations: ctrl.account?.accreditations || [],
          lenderAccreditations: ctrl.account?.lenderAccreditations || [],
          gatewayAccreditations: ctrl.account?.gatewayAccreditations || []
        };
        ctrl.onFinished({ data });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
